// extracted by mini-css-extract-plugin
export default {"ns_chat_page":"ChatPage_ns_chat_page__6aw6m","ns_chat_btn":"ChatPage_ns_chat_btn__dI2Hb"};